import { ActionReducerMap } from '@ngrx/store';
import { IUserState } from './../../state/user.state';
import { ViewProfileReducer } from './user.view.reducer';
import { FeatureFlagsReducer } from '../../feature-flags/reducers/feature-flags-reducer';
import { InvitationsReducer } from './invitations.reducer';

export const UserReducers: ActionReducerMap<IUserState> = {
  viewProfile: ViewProfileReducer,
  featureFlags: FeatureFlagsReducer,
  invitation: InvitationsReducer
};
